export function getSafeReturnPath(raw: unknown): string | null {
  if (typeof raw !== 'string' || raw.trim().length === 0) {
    return null;
  }

  try {
    const url = new URL(raw.trim(), window.location.origin);

    if (url.origin !== window.location.origin) {
      return null;
    }

    return url.pathname + url.search + url.hash;
  } catch {
    return null;
  }
}